// NOTE: UI表示用の名称置換テーブル
// - マスターデータ上の「○○(○○のすがた)」は冗長なので、通常表示では短い名称に揃える
export const POKEMON_DISPLAY_NAME_MAPPING: Record<string, string> = {
  'カイオーガ(カイオーガのすがた)': 'カイオーガ',
  'グラードン(グラードンのすがた)': 'グラードン',
  'コライドン(かんぜんけいたい)': 'コライドン',
  'ミライドン(コンプリートモード)': 'ミライドン',
  'ミミッキュ(ばけたすがた)': 'ミミッキュ',
};

// NOTE: フォーム名がマスターデータ上で重複してしまっているケースは ID で補正する
// - 例: ヒヒダルマ(ダルマモード) が「通常」と「ガラル」の両方に存在する
export const POKEMON_DISPLAY_NAME_MAPPING_BY_ID: Record<number, string> = {
  10178: 'ヒヒダルマ(ガラル/ダルマモード)',
};

type PokemonDisplayNameInput = { id: number; name_ja: string } | string;

/**
 * UI向けに表示名をそろえるヘルパー
 */
export const formatPokemonDisplayName = (input: PokemonDisplayNameInput): string => {
  if (typeof input !== 'string') {
    const mappedById = POKEMON_DISPLAY_NAME_MAPPING_BY_ID[input.id];
    if (mappedById) {
      return mappedById;
    }
    return POKEMON_DISPLAY_NAME_MAPPING[input.name_ja] ?? input.name_ja;
  }

  return POKEMON_DISPLAY_NAME_MAPPING[input] ?? input;
};
